import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import { pathOr as RpathOr } from 'ramda';

function usePartnerInfo(props) {
  const partnerName = RpathOr(null, ['match', 'params', 'partner'], props);
  const partnersRef = firebase.database().ref('/partners')
    .orderByChild('url')
    .equalTo(partnerName)
    .limitToFirst(1);

  const [partner, setPartner] = useState({});
  useEffect(() => {
    partnersRef.on('value', (data) => {
      data.forEach((item) => {
        setPartner(item.val());
      });
    });
    return () => {
      partnersRef.off('value');
    };
  }, [partnerName]);
  return partner;
}

function useTemplatesInfo(partnerKey) {
  const ref = firebase.database()
    .ref(`private/${partnerKey}/templates/`);

  const [templates, setTemplates] = useState({});
  useEffect(() => {
    ref.on('value', (data) => {
      // console.log('::::::: templates', data.val());
      setTemplates(data.val());
      // data.forEach((item) => {
      //   setTemplates(item.val());
      // });
    });
    return () => {
      ref.off('value');
    };
  }, [partnerKey]);
  return templates;
}


export {
  usePartnerInfo,
  useTemplatesInfo,
};



// WEBPACK FOOTER //
// ./src/hooks/index.js